import {
  createUserRequest,
  CreateUserRequestType,
  deleteUserRequest,
  editUserRequest,
  fetchCertainUserRequest,
  fetchUsersRequest,
} from 'api';
import { EditUserRequestType } from 'api/usersApi/types';
import { PaginationType } from 'common';
import { Pagination, Roles } from 'enums';
import {
  setAuthLoading,
  setNotification,
  setPagination,
  setUsers,
  setUsersAfterScroll,
  setUsersLoadingStatus,
} from 'state/actions';
import { setCertainUser } from 'state/actions/users';
import { AppRootStateType } from 'state/reducers';
import { TypedDispatch } from 'state/types';

export const fetchUsers =
  (isScroll: boolean) =>
  async (dispatch: TypedDispatch, getState: () => AppRootStateType) => {
    const { page, search } = {
      page: isScroll ? getState().users.page : Pagination.START_PAGE,
      search: getState().users.search.trim(),
    };

    const shouldOnlyFetchSuperAdmins = getState().auth.user.role === Roles.SUPER_ADMIN;

    const companyId =
      getState().auth.user.role === Roles.SUPER_ADMIN
        ? ''
        : getState().auth.user.company.id;

    try {
      dispatch(setUsersLoadingStatus(true));
      const response = await fetchUsersRequest({
        page,
        q: search || undefined,
        take: Pagination.TAKE,
        companyId,
        ...(shouldOnlyFetchSuperAdmins ? { roles: Roles.SUPER_ADMIN } : {}),
      });

      const pagination: PaginationType = {
        page: response?.data.page,
        count: response?.data.count,
      };

      dispatch(setPagination(pagination));
      dispatch(
        isScroll
          ? setUsersAfterScroll(response?.data.rows)
          : setUsers(response?.data.rows),
      );
    } finally {
      dispatch(setUsersLoadingStatus(false));
    }
  };

export const createUser =
  (data: CreateUserRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createUserRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const deleteUser = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deleteUserRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const editUser =
  (user: EditUserRequestType & { id: string }) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editUserRequest(user);

      dispatch(setNotification(response?.data?.message));

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const fetchCertainUser = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await fetchCertainUserRequest(id);

    dispatch(setCertainUser(response.data));
  } finally {
    dispatch(setAuthLoading(false));
  }
};
